<template>
  <div>
    <el-dialog
        :title="'Tạo icon'"
        :visible.sync="isCreate"
        width="500px"
        :before-close="handleClose"
        top="5vh"
        :close="handleClose"
    >
      <el-form
          :model="formData"
          :rules="rules" ref="formData"
          label-position="left"
          label-width="150px">
        <el-form-item label="Mã định danh" prop="idIcon">
          <el-input v-model="formData.idIcon" maxlength="8" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="Tên" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="Key" prop="key">
          <el-input v-model="formData.key"></el-input>
        </el-form-item>
      </el-form>
      <div class="buttons">
        <el-button
            :loading="loading"
            size="small"
            type="success"
            style="margin-right: 10px"
            @click="handleUpload()"
        >
          Tạo mới
        </el-button>
        <el-button size="small" type="danger" @click="handleClose">
          <i class="el-icon-circle-close"/> Đóng
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import manageDataService from "@/services/AdminService/ManageDataService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "CreateIconSystemDialog",
  data() {
    return {
      formData: {
        idIcon: "",
        name: "",
        key: "",
      },
      loading: false,
      rules: {
        idIcon: [
          {required: true, message: 'Ma định danh không được để trống', trigger: 'change'},
          {min: 8, max: 8, message: 'Yêu cầu 8 ký tự', trigger: 'blur'}
        ],
        name: [
          {required: true, message: 'Tên không được để trống', trigger: 'change'},
        ],
        key: [
          {required: true, message: 'Key không được để trống', trigger: 'change'},

        ],
      }
    }
  },
  props: {
    isCreate: {
      type: Boolean,
      default: false
    },
    listIcon: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    handleClose() {
      this.$refs['formData'].resetFields();
      this.$emit("close");
    },
    handleUpload() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (!this.checkIcon()){
            this.loading = true;
            manageDataService.createIconSystem(this.formData).then((res) => {
              if (res.data.data) {
                NotifyMessage.leftCornerNotificationSuccess("Tạo icon thành công")
              } else {
                NotifyMessage.leftCornerNotificationError("Tạo icon thất bại")

              }
              this.loading = false;
              this.handleClose();
            }).catch((err) => {
              this.loading = false;
              NotifyMessage.leftCornerNotificationError(err.response.data.message)
            })
          } else {
            NotifyMessage.leftCornerNotificationError("Mã đã tồn tại")
          }
        }
      });
    },
    checkIcon() {
      if (this.$props.listIcon.length > 0) {
        for (let i = 0; i < this.$props.listIcon.length; i++) {
          if (this.formData.idIcon === this.$props.listIcon[i].idIcon) {
            return true;
          }
        }
      }else return false;
    }
  }

}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: right;
  text-align: right;
  margin-top: 10px;
}
</style>